import { render } from "./UpgradePlan.vue?vue&type=template&id=693fa069&ts=true"
import script from "./UpgradePlan.vue?vue&type=script&lang=ts"
export * from "./UpgradePlan.vue?vue&type=script&lang=ts"

import exportComponent from "/home/starkoms/webapps/front-comm-starkoms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__